/* eslint-disable import/no-cycle */
import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'budgets';

export default {
  async getById(id) {
    const url = mountUrl(`/${BASE_PATH}/${id}/detail`);
    return api.get(url);
  },
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}`, queryParams);
    return api.get(url);
  },
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, body);
  },
  async update(id, body) {
    const url = mountUrl(`/${BASE_PATH}/${id}`);
    return api.patch(url, body);
  },
  async inactivate(id) {
    const url = mountUrl(`/${BASE_PATH}/${id}`);
    return api.delete(url);
  },
  async duplicate(id) {
    const url = mountUrl(`/${BASE_PATH}/${id}/duplicate`);
    return api.post(url);
  }
};
